<app-layout>
  <div [@routerAnimation]="step">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</app-layout>
